import { useState, useEffect } from "react";
import { Switch } from "antd";
import { notifications } from "../constant/Notify";

const Item = (props) => {
    const isEdit = !!props.data;

    const [dataForm, setDataForm] = useState({
        name: "",
        page_id: "",
        access_token: "",
        status: true,
    });

    useEffect(() => {
        if (props.data) {
            setDataForm({
                name: props.data.name || "",
                page_id: props.data.page_id || "",
                access_token: props.data.access_token || "",
                status: props.data.status === 1 || props.data.status === true,
            });
        } else {
            setDataForm({
                name: "",
                page_id: "",
                access_token: "",
                status: true,
            });
        }
    }, [props.data]);

    const handleChange = (field, value) => {
        setDataForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSave = async () => {
        if (!dataForm.name.trim()) {
            notifications({type: "warning",  mess: "Vui lòng nhập tên page"});
            return;
        }

        if (!dataForm.page_id.trim()) {
            notifications({type: "warning",  mess: "Vui lòng nhập Id page"});
            return;
        }

        if (!dataForm.access_token.trim()) {
            notifications({type: "warning",  mess: "Vui lòng nhập Access token"});
            return;
        }

        const dataSave = {
            ...(isEdit ? { id: props.data.id } : {}),
            name: dataForm.name,
            page_id: dataForm.page_id,
            access_token: dataForm.access_token,
            status: dataForm.status ? 1 : 0,
        };

        props.saveData(dataSave)
        
    };

    return (
        <div className="popup-cent store-edit">
            <div className="content-popup fadeInDown">
                <div className="head-popup">
                    <div className="title">{isEdit ? "Sửa page" : "Thêm page"}</div>
                    <div className="close" onClick={() => props.displayPopup(false)}>×</div>
                </div>
                <div className="body-popup">
                    <div className="items-data row">
                        <div className="title col-3">Tên page</div>
                        <div className="value col-9">
                            <input type="text" className="required" placeholder="Tên page" value={dataForm.name}
                                onChange={(e) => handleChange("name", e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="items-data row">
                        <div className="title col-3">Id page</div>
                        <div className="value col-9">
                            <input type="text" className="required" placeholder="Id page" value={dataForm.page_id}
                                onChange={(e) => handleChange("page_id", e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="items-data row">
                        <div className="title col-3">Access token</div>
                        <div className="value col-9">
                            <input type="text" className="required" placeholder="Access token" value={dataForm.access_token} 
                                onChange={(e) => handleChange("access_token", e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="items-data row">
                        <div className="title col-3">Status</div>
                        <div className="value col-9">
                            <Switch checked={dataForm.status} onChange={(checked) => handleChange("status", checked)} />
                        </div>
                    </div>
                </div>
                <div className="bottom-popup">
                    <div className="button-container">
                        <div className="button-cent style3" onClick={() => props.displayPopup(false)}>
                            <span><i className="fas fa-times"></i></span>Đóng
                        </div>
                        <div className="button-cent" onClick={handleSave}>
                            <span><i className="fas fa-save"></i></span> {isEdit ? "Cập nhật" : "Lưu thông tin"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="overlay" onClick={() => props.displayPopup(false)}></div>
        </div>
    );
};

export default Item;